var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      staticClass: "viq-citation-pill",
      attrs: { title: _vm.source ? _vm.source.title : "Source " + _vm.number },
      on: { click: _vm.handleClick },
    },
    [_vm._v("\n  [" + _vm._s(_vm.number) + "]\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }